import {
    Component
} from '@angular/core';
import {
    TaskBaseMagicComponent,
    magicProviders
} from "@magic-xpa/angular";
//
import { FormControl, FormGroup } from '@angular/forms'; 
import { variable } from '@angular/compiler/src/output/output_ast';
//
@Component({
    selector: 'mga-MostraResultadoPesquisa',
    providers: [...magicProviders],
	styleUrls: ['./MostraResultadoPesquisa.component.css'],
    templateUrl: './MostraResultadoPesquisa.component.html'
}) export class MostraResultadoPesquisa extends TaskBaseMagicComponent {
	//
	// 2020-08-24 (MFCS)
	//
    ngOnInit() {
        super.ngOnInit();
        let group: FormGroup = this.screenFormGroup; 
        (<FormControl>group.controls['URL_Avaliar_OS']).registerOnChange(this.OnChange.bind(this));
      }
    OnChange() {
        if(this.mg.getValue('URL_Avaliar_OS') !== undefined && this.mg.getValue('URL_Avaliar_OS') !== null){
			var fContent = this.mg.getValue('URL_Avaliar_OS');
			if( fContent.toLowerCase().lastIndexOf("http", 0) === 0 ) {
				// Começa com HTTP o valor do campo
				window.open(fContent, "_blank");
			}
        }
    }		
}

